"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tea_1 = require("./tea");
exports.Tea = tea_1.getConfig;
//# sourceMappingURL=index.js.map